import React, { useState, useContext, useEffect } from "react";
import classes from "../styles/smallNav.module.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Image from "next/image";
import { Store } from "@utils/store/ContextStore";
import { useRouter } from "next/router";
import applogo from "../../../public/logo.webp";
import LangugageDropdown from "./languageDropdown";
import WelcomeModal from "src/onboardingModule/components/welcomeModal";
// import UtsavModal from "../views/utsavModal";
import Link from "next/link";
import { ThemeProvider } from "styled-components";
import { Box, Button, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Modal, NoSsr, SwipeableDrawer, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Onboarding from "../../onboardingModule/components/onboardingMobile";
import RFmandal from "@public/assets/icons/RFmandal.svg";
import styles from "../styles/nav.module.css";
import theme from "../styles/theme";
import InstagramIcon from "../../../public/assets/icons/SocialIcons/mdi_instagram.svg";
import TwitterIcon from "../../../public/assets/icons/SocialIcons/mdi_twitter.svg";
import LinkedInIcon from "../../../public/assets/icons/SocialIcons/ri_linkedin_fill.svg";
import FacebookIcon from "../../../public/assets/icons/SocialIcons/uil_facebook.svg";
import LoggedInUserIcon from "../../../public/assets/icons/loggedin_user.svg";
import SettingsIcon from "../../../public/assets/icons/Navbar/carbon_settings.svg";
import LogoutIcon from "../../../public/assets/icons/Navbar/fe_logout.svg";
import GooglePlayIcon from "../../../public/assets/icons/Navbar/mobile_app_store_badge.jpg";
import { useTranslation } from "react-i18next";
import { logout } from "src/onboardingModule/queries/auth.queries";
import { completeLogout } from "@utils/auth/logout";
import UtsavModal from "./UtsavModal";
import { useDispatch } from "react-redux";
import { deleteUserData } from "@utils/reduxToolkit/features/userSlice";
function SmallScreenNavBar({
  templeName,
  backButtonPath,
  data,
  user,
  isBharatAgri
}) {
  const router = useRouter();
  const [swipeNavbarState, setSwipeNavbarState] = useState({
    left: false
  });
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const {
    t
  } = useTranslation();
  const [scrollDown, setScrollDown] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [blogsPage, setBlogsPage] = useState(router.pathname === "/blogs/[...params]");
  const dispatch = useDispatch();
  const closeLoginModal = () => {
    setLoginModalOpen(false);
    // setReset(true);
    //setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openLoginModal = () => {
    setLoginModalOpen(true);
    // setReset(false);
  };
  const toggleLogoutModal = () => {
    setOpenLogoutModal(!openLogoutModal);
  };
  const handleLogout = async setProcessing => {
    logout(loggedInUser.accessToken);
    completeLogout(setProcessing);
    dispatch(deleteUserData());
  };
  const toggleDrawer = (anchor, open) => event => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setSwipeNavbarState({
      ...swipeNavbarState,
      [anchor]: open
    });
  };
  const handleItemClick = (id, path, e) => {
    e.preventDefault();
    router.push(path, undefined, {
      shallow: true,
      locale: router.locale
    });
    toggleDrawer("left", false);
  };
  const handleClick = () => {
    let url = router.pathname;
    switch (url) {
      case "/puja/registration/review":
      case "/puja/sub/[id]":
      // case "/puja/[id]/[eventid]/all-pujas":
      case "/puja/[id]/[eventid]/[subeventid]":
      case "/puja/registration/[eventid]/[subeventid]/receipt":
        router.push(`/puja`);
        break;
      default:
        router.push("/home");
        break;
    }
  };
  const list = anchor => <Box sx={{
    width: 300
  }} role="presentation" onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)} data-sentry-element="Box" data-sentry-component="list" data-sentry-source-file="smallScreenNavBar.jsx">
      <Grid container direction={"column"} justifyContent={"space-between"} height={"100vh"} sx={{
      backgroundColor: theme.palette.paper.main
    }} data-sentry-element="Grid" data-sentry-source-file="smallScreenNavBar.jsx">
        <Grid item data-sentry-element="Grid" data-sentry-source-file="smallScreenNavBar.jsx">
          <List data-sentry-element="List" data-sentry-source-file="smallScreenNavBar.jsx">
            {loggedInUser.name !== "guest" && <>
                <Link href={`/profile/${loggedInUser.uid}`}>
                  <ListItem sx={{
                backgroundColor: theme.palette.paper.secondary
              }}>
                    {loggedInUser?.dp ? <Image src={loggedInUser.dp || ""} alt={t("dp")} height={30} width={30} style={{
                  borderRadius: "50%"
                }} /> : <LoggedInUserIcon />}
                    <ListItemButton>
                      <ListItemText primary={loggedInUser.name !== "guest" && loggedInUser.name} />
                    </ListItemButton>
                  </ListItem>
                </Link>

                <ListItem disablePadding sx={{
              pt: 2
            }}>
                  <ListItemButton className={`${router.pathname === "/your-puja" ? styles.activeItem : ""}`} onClick={e => handleItemClick("puja", "/your-puja", e)}>
                    <ListItemText primary={t("your-pujas")} />
                  </ListItemButton>
                </ListItem>

                {/* <Link href={`/notification`}>
                  <ListItem sx={{ pb: 0 }}>
                    <NotificationIcons />
                    <ListItemButton
                      className={`${
                        router.pathname === `/notification`
                          ? styles.activeItem
                          : ""
                      }`}
                    >
                      <ListItemText primary={t("notifications")} />
                    </ListItemButton>
                  </ListItem>
                 </Link> */}
                {/* <Link href={`/settings`}>
                  <ListItem sx={{ pb: 2 }}>
                    <SettingsIcon />
                    <ListItemButton
                      className={`${
                        router.pathname === `/settings` ? styles.activeItem : ""
                      }`}
                    >
                      <ListItemText primary={t("settings")} />
                    </ListItemButton>
                  </ListItem>
                 </Link>
                 <Divider component="li" /> */}
              </>}
            <ListItem disablePadding sx={{
            pt: 2
          }} data-sentry-element="ListItem" data-sentry-source-file="smallScreenNavBar.jsx">
              <ListItemButton className={`${router.pathname === "/home" ? styles.activeItem : ""}`} onClick={e => handleItemClick("home", "/home", e)} data-sentry-element="ListItemButton" data-sentry-source-file="smallScreenNavBar.jsx">
                <ListItemText primary={t("home")} data-sentry-element="ListItemText" data-sentry-source-file="smallScreenNavBar.jsx" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding data-sentry-element="ListItem" data-sentry-source-file="smallScreenNavBar.jsx">
              <ListItemButton className={`${router.pathname === "/puja" ? styles.activeItem : ""}`} onClick={e => handleItemClick("pujas", "/puja", e)} data-sentry-element="ListItemButton" data-sentry-source-file="smallScreenNavBar.jsx">
                <ListItemText primary={t("pujas")} data-sentry-element="ListItemText" data-sentry-source-file="smallScreenNavBar.jsx" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding data-sentry-element="ListItem" data-sentry-source-file="smallScreenNavBar.jsx">
              <ListItemButton className={`${router.pathname === "/blogs" ? styles.activeItem : ""}`} onClick={e => {
              handleItemClick("blogs", "/blogs", e);
            }} data-sentry-element="ListItemButton" data-sentry-source-file="smallScreenNavBar.jsx">
                <ListItemText primary={t("Blogs")} data-sentry-element="ListItemText" data-sentry-source-file="smallScreenNavBar.jsx" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding data-sentry-element="ListItem" data-sentry-source-file="smallScreenNavBar.jsx">
              <ListItemButton className={`${router.pathname === "/community" ? styles.activeItem : ""}`} onClick={e => handleItemClick("community", "/community", e)} data-sentry-element="ListItemButton" data-sentry-source-file="smallScreenNavBar.jsx">
                <ListItemText primary={t("community")} data-sentry-element="ListItemText" data-sentry-source-file="smallScreenNavBar.jsx" />
              </ListItemButton>
            </ListItem>

            {loggedInUser.name === "guest" && <ListItem sx={{
            mt: 1
          }}>
                <Grid container spacing={4}>
                  <Grid item xs={7}>
                    <Link href="https://play.google.com/store/apps/details?id=com.applex.utsav" className={styles.section1_download_link} target="_blank">
                      <Button className={`${styles.downloadBtn}`}
                  // onClick={goToSignUp}
                  sx={{
                    mr: 1,
                    width: "100%"
                  }}>
                        {t("download-app")}
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item xs={5}>
                    <Button className={styles.navLoginBtn} onClick={openLoginModal}>
                      {t("login")}
                    </Button>
                  </Grid>
                </Grid>
              </ListItem>}

            {loggedInUser.name !== "guest" && <>
                <Divider component="li" />
                <Link href={`/settings`}>
                  <ListItem sx={{
                pb: 2
              }}>
                    <SettingsIcon />
                    <ListItemButton className={`${router.pathname === `/settings` ? styles.activeItem : ""}`}>
                      <ListItemText primary={t("settings")} />
                    </ListItemButton>
                  </ListItem>
                </Link>
              </>}
          </List>
        </Grid>

        {loggedInUser.name !== "guest" ? <Grid item>
            <List sx={{
          pb: 0
        }}>
              <ListItem>
                <Grid container direction={"column"}>
                  <Grid item sx={{
                mb: "10px"
              }}>
                    <Typography variant="h6">{t("download-app")}</Typography>
                  </Grid>
                  <Grid item sx={{
                mb: "10px"
              }}>
                    <Image priority src={GooglePlayIcon} height={40} width={120} alt="" />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem sx={{
            color: "red",
            boxShadow: "2px 1px 8px 1px #0000001F",
            backgroundColor: theme.palette.paper.secondary
          }} onClick={e => {
            e.preventDefault();
            toggleLogoutModal();
          }}>
                <LogoutIcon />
                <ListItemButton>
                  <ListItemText primary={t("logout")} />
                </ListItemButton>
              </ListItem>
            </List>
          </Grid> : <List sx={{
        pb: 0
      }}>
            <ListItem sx={{
          boxShadow: "2px 1px 8px 1px #0000001F",
          backgroundColor: theme.palette.paper.secondary
        }}>
              <Grid container direction={"column"} sx={{
            mt: 2.5,
            mb: 2.5
          }}>
                <Grid item sx={{
              mb: 1.5
            }}>
                  <Typography variant="h6">{t("follow-us-on")}</Typography>
                </Grid>
                <Grid item container>
                  <Link href={"https://www.linkedin.com/company/utsavapp/"} target="_blank" rel="noopener noreferrer">
                    <Grid item sx={{
                  mr: 2
                }}>
                      <LinkedInIcon />
                    </Grid>
                  </Link>
                  <Link href={"https://www.facebook.com/utsav.app.community"} target="_blank" rel="noopener noreferrer">
                    <Grid item sx={{
                  mr: 2
                }}>
                      <FacebookIcon />
                    </Grid>
                  </Link>
                  <Link href={"https://www.instagram.com/utsav_app/"} target="_blank" rel="noopener noreferrer">
                    <Grid item sx={{
                  mr: 2
                }}>
                      <InstagramIcon />
                    </Grid>
                  </Link>
                  <Link href={"https://twitter.com/utsav_app"} target="_blank" rel="noopener noreferrer">
                    <Grid item sx={{
                  mr: 2
                }}>
                      <TwitterIcon />
                    </Grid>
                  </Link>
                </Grid>
              </Grid>
            </ListItem>
          </List>}
      </Grid>
    </Box>;
  return <div className={styles.visibleSmallScreenNavbar} data-sentry-component="SmallScreenNavBar" data-sentry-source-file="smallScreenNavBar.jsx">
      <ThemeProvider theme={theme} data-sentry-element="ThemeProvider" data-sentry-source-file="smallScreenNavBar.jsx">
        <div className={`${styles.root}`} id="root">
          <SwipeableDrawer anchor={"left"} open={swipeNavbarState["left"]} onClose={toggleDrawer("left", false)} onOpen={toggleDrawer("left", true)}
        // classes={{ paper: classes.paper }}
        data-sentry-element="SwipeableDrawer" data-sentry-source-file="smallScreenNavBar.jsx">
            {list("left")}
          </SwipeableDrawer>
          <>
            {!blogsPage ? <div className={`${styles.nav} ${styles.smnav} 
                  ${scrollDown ? styles.boxShadow : ""}
                  `}>
                <div className={styles.sidebar_btn} onClick={toggleDrawer("left", true)}>
                  <NoSsr>
                    <MenuIcon className={styles.notesIcon} />
                  </NoSsr>
                </div>
                <div className={`${styles.utsavLogo} ${styles.utsavLogo}`} onClick={e => {
              e.preventDefault();
              handleClick();
            }}>
                  {isBharatAgri ? <Box sx={{
                position: "relative",
                width: "240px",
                height: "40px"
              }}>
                      <Image src={"/assets/newEvent/pujaDetails/brandLogo/Utsav_BharatAgri.svg"} alt="Utsav&BharatAgri" fill={true} objectFit="cover" />
                    </Box> : <>
                      <div className={`${styles.section5_box_header_logobox}`}>
                        <Image src={applogo} alt={t("utsav-logo")} className={`${styles.section5_box_header_logobox_img}`} width={25} height={25} priority />
                      </div>
                      <div className={`${styles.section5_box_header_detbox}`}>
                        <div className={`${styles.section5_box_header_detbox_head}`}>
                          {t("utsav")}
                        </div>
                      </div>
                    </>}
                </div>
                <LangugageDropdown />
              </div> : <div className={`${styles.nav} ${styles.smnav} 
                  ${scrollDown ? styles.boxShadow : ""}
                  `}>
                <div className={`${styles.blogUtsavLogo}`} onClick={e => {
              e.preventDefault();
              handleClick();
            }}>
                  <div className={`${styles.section5_box_header_logobox}`}>
                    <Image src={applogo} alt={t("utsav-logo")} className={`${styles.section5_box_header_logobox_img}`} width={30} height={30} priority />
                  </div>

                  <div className={`${styles.section5_box_header_detbox_head}`}>
                    {t("utsav")}
                  </div>
                </div>

                <div className={styles.sidebar_btn} onClick={toggleDrawer("left", true)}>
                  <NoSsr>
                    <MenuIcon className={styles.notesIcon} />
                  </NoSsr>
                </div>
              </div>}

            {/* <Onboarding1 open={isLoginModalOpen} handleClose={closeLoginModal}/> */}
            {/* <Onboarding1
                  open={isLoginModalOpen}
                  handleClose={closeLoginModal}
                /> */}

            <Modal open={isLoginModalOpen} onClose={closeLoginModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" BackdropProps={{
            onClick: event => {
              if (event.target.id !== "closeButton") {
                event.preventDefault();
              }
            }
          }} data-sentry-element="Modal" data-sentry-source-file="smallScreenNavBar.jsx">
              <Box className={styles.modalBox} data-sentry-element="Box" data-sentry-source-file="smallScreenNavBar.jsx">
                <div className={styles.modalNav}>
                  {/* <NavSmallScreen backButtonPath={closeLoginModal} /> */}
                  <div className={classes.navHead}>
                    <ArrowBackIcon onClick={closeLoginModal} data-sentry-element="ArrowBackIcon" data-sentry-source-file="smallScreenNavBar.jsx" />
                    <div className={classes.utsavFont}>
                      <Image src={applogo} alt={t("utsav-logo")} width="35" height="35" data-sentry-element="Image" data-sentry-source-file="smallScreenNavBar.jsx" />
                      <Typography sx={{
                      fontSize: "25px"
                    }} data-sentry-element="Typography" data-sentry-source-file="smallScreenNavBar.jsx">
                        {t("utsav")}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className={styles.modalContent}>
                  <div>
                    <Onboarding closeLoginModal={closeLoginModal} data-sentry-element="Onboarding" data-sentry-source-file="smallScreenNavBar.jsx" />
                  </div>
                  <div className={styles.ModalMandal}>
                    <RFmandal data-sentry-element="RFmandal" data-sentry-source-file="smallScreenNavBar.jsx" />
                  </div>
                </div>
              </Box>
            </Modal>
            {/* <Onboarding1
                  isLoginModalOpen={isLoginModalOpen}
                  handleClose={closeLoginModal}
                /> */}
          </>

          <WelcomeModal open={isModalOpen} onClose={closeModal} data-sentry-element="WelcomeModal" data-sentry-source-file="smallScreenNavBar.jsx" />
          {openLogoutModal && <UtsavModal open={openLogoutModal} toggleModal={toggleLogoutModal} heading={t("logout")} message={t("do-you-want-to-continue")} acceptMsg={t("logout")} onAccept={handleLogout} rejectMsg={t("cancel")} positive={false} />}
        </div>
      </ThemeProvider>
    </div>;
}
export default SmallScreenNavBar;